import React from 'react';
import { RedirectWithoutLastLocation } from 'react-router-last-location';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faHome,
  faCar,
  faMicrochip,
  faBell,
  faExchangeAlt,
  faTh,
  faExclamationCircle,
  faTools,
  // faSlidersH,
  // faUsers,
  faBriefcase,
  faUsers,
  // faHdd,
  faBuilding,
  faFax,
  faSatelliteDish,
  faServer,
} from '@fortawesome/free-solid-svg-icons';

// import { ReactComponent as companyIcon } from '@assets/svg/company.svg';
// import FleetIcon from '@common/components/ui/SpecialIcons/FleetIcon';

import Usuarios from '@pages/AdminUsuarios';
import CrearUsuarios from '@pages/UsersEditCreate';

import Profile from '@pages/Profile';

import GraficasDispositivo from '@pages/GraficasDispositivo/GraficasDispositivo';
import GraficasDispositivoVariable from '@pages/GraficasDispositivoVariable/GraficasDispositivoVariable';
// import Home from '@pages/Home';
import HomeDispositivo from '@pages/HomeDispositivo';
import HomeBusinessType from '@pages/HomeBusinessType';

import CreateInverters from '@pages/CreateInverters';

import TipoNegocio from '@pages/BusinessType';
import Dispositivos from '@pages/Dispositivos';
import Gateway from '@pages/Gateway';
import DeviceTypes from '@pages/DeviceTypes';
import Firmwares from '@pages/Firmwares';
// import Portals from '@pages/Portals';
import DipositivosLogs from '@pages/Dispositivos_Logs';
import CreateDevices from '@pages/CreateDevices';
// import DeviceTypesEditCreate from '@pages/DeviceTypesEditCreate';
import CreateDevicesType from '@pages/CreateDevicesType';
import DevicesTypeView from '@pages/DevicesTypeView';
import CreateFirmwares from '@pages/createFirmwares';
// import CreatePortals from '@pages/CreatePortals';
import CreateBusinessType from '@pages/CreateBusinessType';
import CreateGateway from '@pages/CreateGateway';

import Alarmas from '@pages/Alarmas';
import Alarmas_EditCreate from '@pages/Alarmas_EditCreate';
import Alarmas_Notifications from '@pages/Alarmas_Notifications';

// import InverterAlarms from '@pages/InverterAlarms';
import InverterEditCreate from '@pages/InvertersEditCreate';

import DeviceAlarms from '@pages/DeviceAlarms';
import DevicesEditCreate from '@pages/DevicesEditCreate';
// import Model_Inverters from '@pages/Model_Inverters';
import CreateModelInverter from '@pages/ModelInvertersCreateEdit';

// eslint-disable-next-line
import Clientes from '@pages/Clientes/Clientes';
// eslint-disable-next-line
import ClientesEditCreate from '@pages/ClientesEditCreate/ClientesEditCreate';
// eslint-disable-next-line
import ClientesDetail from '@pages/ClientesDetail/ClientesDetail';
// eslint-disable-next-line
import DashboardGeneral from '@pages/DashboardGeneral';

import MetricsDetail from '@pages/MetricsDetail/MetricsDetail';

// import Icon from '@ant-design/icons/lib/components/Icon';
import RenderRoutes from './components/RenderRoutes';

const iconProps = {
  className: 'anticon',
  style: { fontSize: 21, minWidth: 'auto' },
};

const MAIN_ROUTES = [
  {
    path: '/',
    key: 'MAIN',
    exact: true,
    // eslint-disable-next-line react/jsx-filename-extension
    component: () => <RedirectWithoutLastLocation to="/tablero-general" />,
  },
  {
    path: '/tablero-general',
    key: 'GENERAL',
    exact: true,
    component: RenderRoutes,
    menuItem: {
      name: 'menu_items.main.general_board',
      icon: <FontAwesomeIcon icon={faHome} {...iconProps} />,
    },
    routes: [
      {
        path: '/tablero-general',
        key: 'GENERAL_GENERAL',
        exact: true,
        component: HomeBusinessType,
      },
    ],
  },
  {
    path: '/tablero-devices/:business_type_id',
    key: 'GENERAL_DEVICES',
    exact: true,
    component: RenderRoutes,
    routes: [
      {
        path: '/tablero-devices/:business_type_id',
        key: 'GENERAL_GENERAL_DEVICES',
        exact: true,
        component: HomeDispositivo,
      },
    ],
  },
  {
    path: '/tablero-comunidades/:business_type_id',
    key: 'GENERAL_COMUNIDADES',
    exact: true,
    component: RenderRoutes,
    routes: [
      {
        path: '/tablero-comunidades/:business_type_id',
        key: 'GENERAL_GENERAL_COMUNIDADES',
        exact: true,
        component: DashboardGeneral,
      },
    ],
  },
  {
    path: '/inversores',
    key: 'INVERTER_EDIT_CREATE',
    component: RenderRoutes,
    // menuItem: {
    //   isAbstract: true,
    //   name: 'menu_items.main.general_board',
    //   icon: <FontAwesomeIcon icon={faSlidersH} {...iconProps} />,
    // },
    routes: [
      {
        path: ['/inversores/crear', '/inversores/editar/:inverter_id'],
        key: 'GENERAL_GENERAL',
        exact: true,
        component: CreateInverters,
        // menuItem: {
        //   name: 'menu_items.main.general_board',
        //   icon: <FontAwesomeIcon icon={faSlidersH} {...iconProps} />,
        // },
      },
      {
        path: '/inversores/crear',
        key: 'GENERAL_GENERAL',
        exact: true,
        component: CreateInverters,
      },
    ],
  },
  {
    path: '/dispositivos',
    key: 'DEVICES',
    component: RenderRoutes,
    menuItem: {
      isAbstract: true,
      name: 'menu_items.main.devices',
      icon: <FontAwesomeIcon icon={faMicrochip} {...iconProps} />,
    },
    routes: [
      {
        path: '/dispositivos',
        key: 'DEVICES__ROOT',
        exact: true,
        component: <RedirectWithoutLastLocation to="/dispositivos/administrar" />,
      },
      {
        path: '/dispositivos/negocio',
        key: 'TIPO_NEGOCIO__ADMIN',
        exact: true,
        component: TipoNegocio,
        menuItem: {
          name: 'menu_items.main.business_type',
          icon: <FontAwesomeIcon icon={faBriefcase} {...iconProps} />,
        },
      },
      {
        path: '/dispositivos/administrar',
        key: 'DEVICES__ADMIN',
        exact: true,
        component: Dispositivos,
        menuItem: {
          name: 'menu_items.main.devices_manage_devices',
          icon: <FontAwesomeIcon icon={faTh} {...iconProps} />,
        },
      },
      {
        path: '/dispositivos/tipo-dispositivo',
        key: 'TIPO_DISPOSITIVO__ADMIN',
        exact: true,
        component: DeviceTypes,
        menuItem: {
          name: 'menu_items.main.device_types',
          icon: <FontAwesomeIcon icon={faSatelliteDish} {...iconProps} />,
        },
      },
      {
        path: '/dispositivos/gateway',
        key: 'GATEWAY__ADMIN',
        exact: true,
        component: Gateway,
        menuItem: {
          name: 'menu_items.main.gateway',
          icon: <FontAwesomeIcon icon={faServer} {...iconProps} />,
        },
      },
      {
        path: '/dispositivos/administrar/firmware',
        key: 'FIRMWARE__ADMIN',
        exact: true,
        component: Firmwares,
        menuItem: {
          name: 'menu_items.main.firmware_manage',
          icon: <FontAwesomeIcon icon={faTools} {...iconProps} />,
        },
      },
      /* {
        path: '/dispositivos/administrar/portal',
        key: 'PORTAL__ADMIN',
        exact: true,
        component: Portals,
        menuItem: {
          name: 'menu_items.main.portal_manage',
          icon: <IconPortal />,
          // icon: <FontAwesomeIcon
          //   icon={iconPortal}
          //   {...iconProps}
          // />,
        },
      },
      {
        path: '/dispositivos/administrar/model-inverters',
        key: 'MODEL__INVERTERS__ADMIN',
        exact: true,
        component: Model_Inverters,
        menuItem: {
          name: 'menu_items.main.model_inverter',
          icon: <FontAwesomeIcon icon={faSlidersH} {...iconProps} />,
        },
      }, */
      {
        path: '/dispositivos/logs',
        key: 'DEVICES__LOGS',
        exact: true,
        component: DipositivosLogs,
        menuItem: {
          name: 'menu_items.main.devices_logs',
          icon: <FontAwesomeIcon icon={faExclamationCircle} {...iconProps} />,
        },
      },
      {
        path: '/dispositivos/tipo-dispositivo/crear-tipo-dispositivo',
        key: 'DEVICE_TYPE_CREATE',
        exact: true,
        component: CreateDevicesType,
        // menuItem: {
        //   name: 'menu_items.main.devices_logs',
        //   icon: <FontAwesomeIcon icon={faUsers} {...iconProps} />,
        // },
      },
      /* {
        path: '/dispositivos/tipo-dispositivo/crear-tipo-dispositivo-2',
        key: 'DEVICE_TYPE_CREATE',
        exact: true,
        component: CreateDevicesType,
        // menuItem: {
        //   name: 'menu_items.main.devices_logs',
        //   icon: <FontAwesomeIcon icon={faUsers} {...iconProps} />,
        // },
      }, */
      {
        path: '/dispositivos/tipo-dispositivo/editar-tipo-dispositivo',
        key: 'DEVICE_TYPE_EDIT',
        exact: true,
        component: CreateDevicesType,
        // menuItem: {
        //   name: 'menu_items.main.devices_logs',
        //   icon: <FontAwesomeIcon icon={faUsers} {...iconProps} />,
        // },
      },
      {
        path: '/dispositivos/tipo-dispositivo/ver-tipo-dispositivo',
        key: 'DEVICE_TYPE_EDIT',
        exact: true,
        component: DevicesTypeView,
        // menuItem: {
        //   name: 'menu_items.main.devices_logs',
        //   icon: <FontAwesomeIcon icon={faUsers} {...iconProps} />,
        // },
      },
      {
        path: '/dispositivos/crear-dispositivo',
        key: 'DEVICES__CREATE',
        exact: true,
        component: CreateDevices,
        // menuItem: {
        //   name: 'menu_items.main.devices_logs',
        //   icon: <FontAwesomeIcon icon={faUsers} {...iconProps} />,
        // },
      },
      {
        path: '/dispositivos/editar-dispositivo',
        key: 'DEVICES__CREATE',
        exact: true,
        component: CreateDevices,
        // menuItem: {
        //   name: 'menu_items.main.devices_logs',
        //   icon: <FontAwesomeIcon icon={faUsers} {...iconProps} />,
        // },
      },
      {
        path: '/dispositivos/gateway/crear-gateway',
        key: 'GATEWAY__CREATE',
        exact: true,
        component: CreateGateway,
        // menuItem: {
        //   name: 'menu_items.main.devices_logs',
        //   icon: <FontAwesomeIcon icon={faUsers} {...iconProps} />,
        // },
      },
      {
        path: '/dispositivos/gateway/editar-gateway',
        key: 'GATEWAY__CREATE',
        exact: true,
        component: CreateGateway,
        // menuItem: {
        //   name: 'menu_items.main.devices_logs',
        //   icon: <FontAwesomeIcon icon={faUsers} {...iconProps} />,
        // },
      },
      {
        path: '/dispositivos/firmware/crear-firmware',
        key: 'FIRMWARE_CREATE',
        exact: true,
        component: CreateFirmwares,
        // menuItem: {
        //   name: 'menu_items.main.devices_logs',
        //   icon: <FontAwesomeIcon icon={faUsers} {...iconProps} />,
        // },
      },
      {
        path: '/dispositivos/firmware/editar-firmware',
        key: 'DEVICES__CREATE',
        exact: true,
        component: CreateFirmwares,
        // menuItem: {
        //   name: 'menu_items.main.devices_logs',
        //   icon: <FontAwesomeIcon icon={faUsers} {...iconProps} />,
        // },
      },
      /* {
        path: '/dispositivos/portal/crear-portal',
        key: 'PORTAL_CREATE',
        exact: true,
        component: CreatePortals,
        // menuItem: {
        //   name: 'menu_items.main.devices_logs',
        //   icon: <FontAwesomeIcon icon={faUsers} {...iconProps} />,
        // },
      },
      {
        path: '/dispositivos/portal/editar-portal',
        key: 'PORTAL_EDIT',
        exact: true,
        component: CreatePortals,
        // menuItem: {
        //   name: 'menu_items.main.devices_logs',
        //   icon: <FontAwesomeIcon icon={faUsers} {...iconProps} />,
        // },
      }, */
      {
        path: '/dispositivos/negocio/crear-negocio',
        key: 'BUSINESS_TYPE_CREATE',
        exact: true,
        component: CreateBusinessType,
      },
      {
        path: '/dispositivos/negocio/tipo-negocio',
        key: 'BUSINESS_TYPE_EDIT',
        exact: true,
        component: CreateBusinessType,
      },
      /* {
        path: '/dispositivos/model-inverters/crear-model-inverter',
        key: 'MODEL_INVERTER_CREATE',
        exact: true,
        component: CreateModelInverter,
        // menuItem: {
        //   name: 'menu_items.main.devices_logs',
        //   icon: <FontAwesomeIcon icon={faUsers} {...iconProps} />,
        // },
      }, */
      {
        path: '/dispositivos/model-inverters/edit-model-inverter',
        key: 'MODEL_INVERTER_EDIT',
        exact: true,
        component: CreateModelInverter,
        // menuItem: {
        //   name: 'menu_items.main.devices_logs',
        //   icon: <FontAwesomeIcon icon={faUsers} {...iconProps} />,
        // },
      },

    ],
  },
  {
    path: '/reglas',
    key: 'RULES',
    menuItem: {
      isAbstract: true,
      name: 'menu_items.main.alarms_rules',
      icon: <FontAwesomeIcon icon={faBell} {...iconProps} />,
    },
    component: RenderRoutes,
    routes: [
      {
        path: '/reglas',
        key: 'RULES__ROOT',
        exact: true,
        component: () => <RedirectWithoutLastLocation to="/reglas/predeterminadas" />,
      },
      {
        path: '/reglas/dinamicas',
        key: 'RULES__DYNAMIC',
        exact: true,
        component: Alarmas,
        menuItem: {
          name: 'menu_items.main.alarms_rules_dynamic',
          icon: <FontAwesomeIcon icon={faExchangeAlt} {...iconProps} />,
        },
      },
      {
        path: ['/reglas/dinamicas/crear', '/reglas/dinamicas/:alarm_id'],
        key: 'RULES__DYNAMIC',
        exact: true,
        component: Alarmas_EditCreate,
      },
      {
        path: '/reglas/predeterminadas/:alarm_id',
        key: 'RULES__DEFAULT',
        exact: true,
        component: Alarmas_EditCreate,
      },
      {
        path: ['/reglas/inversores/crear', '/reglas/inversores/:alarm_id'],
        key: 'RULES__INVERTERS',
        exact: true,
        component: InverterEditCreate,
      },
      {
        path: ['/reglas/dispositivos/crear', '/reglas/dispositivos/:alarm_id'],
        key: 'RULES__DEVICE',
        exact: true,
        component: DevicesEditCreate,
      },
      {
        path: '/reglas/notificaciones',
        key: 'RULES__NOTIFICATIONS',
        exact: true,
        component: Alarmas_Notifications,
        menuItem: {
          name: 'menu_items.main.alarms_rules_notifications',
          icon: <FontAwesomeIcon icon={faExclamationCircle} {...iconProps} />,
        },
      },
      /* {
        path: '/reglas/inversores',
        key: 'RULES__INVERTERS_DEFAULT',
        exact: true,
        component: InverterAlarms,
        menuItem: {
          name: 'menu_items.main.alarms_rules_invertes',
          icon: <FontAwesomeIcon icon={faHdd} {...iconProps} />,
        },
      }, */
      {
        path: '/reglas/dispositivos',
        key: 'RULES__DEVICE_DEFAULT',
        exact: true,
        component: DeviceAlarms,
        menuItem: {
          name: 'menu_items.main.alarms_rules_device',
          icon: <FontAwesomeIcon icon={faFax} {...iconProps} />,
        },
      },
      // {
      //   path: '/reglas/predeterminadas/:alarm_id',
      //   key: 'RULES__DEFAULT',
      //   exact: true,
      //   component: Alarmas_EditCreate,
      // },
      // {
      //   path: '/reglas/notificaciones',
      //   key: 'RULES__NOTIFICATIONS',
      //   exact: true,
      //   component: Alarmas_Notifications,
      //   menuItem: {
      //     name: 'menu_items.main.alarms_rules_notifications',
      //     icon: <FontAwesomeIcon icon={faExclamationCircle} {...iconProps} />,
      //   },
      // },
    ],
  },
  {
    path: '/tablero-general/:device',
    key: 'GRAFICAS_DISPOSITIVO',
    exact: true,
    component: RenderRoutes,

    routes: [
      {
        path: '/tablero-general/:device',
        key: 'GRAFICAS_DISPOSITIVOS',
        exact: true,
        component: GraficasDispositivoVariable,
        menuItem: {
          name: 'menu_items.main.general_board',
          icon: <FontAwesomeIcon icon={faCar} {...iconProps} />,
        },
      },
    ],
  },
  {
    path: '/tablero-general/almacenamiento/:device',
    key: 'GRAFICAS_DISPOSITIVOS_ALMACENAMIENTO',
    exact: true,
    component: RenderRoutes,

    routes: [
      {
        path: '/tablero-general/almacenamiento/:device',
        key: 'GRAFICAS_DISPOSITIVOS_ALMACENAMIENTO',
        exact: true,
        component: GraficasDispositivo,
        menuItem: {
          name: 'menu_items.main.general_board',
          icon: <FontAwesomeIcon icon={faCar} {...iconProps} />,
        },
      },
    ],
  },
  {
    path: '/metricas',
    key: 'METRICAS',
    exact: true,
    component: RenderRoutes,
    routes: [
      {
        path: '/metricas',
        key: 'METRICAS',
        exact: true,
        component: MetricsDetail,
      },
    ],
  },
  {
      path: '/clientes',
      key: 'LISTA_CLIENTES',
      // exact: true,
      component: RenderRoutes,
      menuItem: {
        name: 'menu_items.main.clients',
        icon: <FontAwesomeIcon icon={faBuilding} {...iconProps} />,
      },
      routes: [
        {
          path: '/clientes',
          key: 'CLIENTES',
          exact: true,
          component: Clientes,
        },
        {
          path: '/clientes/crear-cliente',
          key: 'CLIENTES',
          exact: true,
          component: ClientesEditCreate,
        },
        {
          path: '/clientes/editar-cliente',
          key: 'CLIENTES',
          exact: true,
          component: ClientesEditCreate,
        },
        {
          path: '/clientes/:id',
          key: 'CLIENTES',
          exact: true,
          component: ClientesDetail,
        },
      ],
  },
  {
    path: '/usuarios',
    key: 'LISTA_USUARIOS',
    // exact: true,
    component: RenderRoutes,
    menuItem: {
      name: 'menu_items.main.users',
      icon: <FontAwesomeIcon icon={faUsers} {...iconProps} />,
    },
    routes: [
      {
        path: '/usuarios',
        key: 'USUARIOS',
        exact: true,
        component: Usuarios,
      },
      {
        path: '/usuarios/crear-usuario',
        key: 'CREAR-USUARIO',
        exact: true,
        component: CrearUsuarios,
      },
      {
        path: '/usuarios/editar-usuario',
        key: 'EDITAR-USUARIOS',
        exact: true,
        component: CrearUsuarios,
      },
    ],
  },
  {
    path: '/perfil',
    key: 'PERFIL',
    // exact: true,
    component: RenderRoutes,
    // menuItem: {
    //   name: 'menu_items.main.users',
    //   icon: <FontAwesomeIcon icon={faUser} {...iconProps} />,
    // },
    routes: [
      {
        path: '/perfil',
        key: 'PERFIL_EDIT',
        exact: true,
        component: Profile,
      },
    ],
  },
];

export default MAIN_ROUTES;
